angular.module('cpm').config(($routeProvider) => {
    'use strict';
    $routeProvider
        .when('/user', {
            controller: 'UserSettingsCtrl as user',
            templateUrl: 'user/user.html',
            role: 'USER',
            title: 'User'
        });
});
